/* Silvano — scripts propios (vanilla, sin librerías) */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.mt-reveal:not(.mt-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('mt-visible');
        if (e.target.hasAttribute('data-mt-contar')) contar(e.target);
        e.target.querySelectorAll('[data-mt-contar]').forEach(contar);
        io.unobserve(e.target);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function contar(el) {
    if (el.dataset.mtHecho) return;
    el.dataset.mtHecho = '1';
    var fin = parseFloat(el.getAttribute('data-mt-contar')) || 0;
    if (reduce) { el.textContent = fin; return; }
    var dur = 1600, t0 = null;
    function paso(t) {
      if (!t0) t0 = t;
      var p = Math.min((t - t0) / dur, 1);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(fin * e);
      if (p < 1) requestAnimationFrame(paso);
    }
    requestAnimationFrame(paso);
  }

  function initParallax() {
    var els = document.querySelectorAll('[data-mt-parallax]');
    if (!els.length || reduce || window.innerWidth < 990) return;
    var ticking = false;
    function update() {
      els.forEach(function (el) {
        var f = parseFloat(el.getAttribute('data-mt-parallax')) || 0;
        var r = el.getBoundingClientRect();
        var off = (r.top + r.height / 2 - window.innerHeight / 2) * f * -0.01;
        el.style.transform = 'translate3d(0,' + off.toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  function initProducto() {
    document.querySelectorAll('[data-mt-producto]').forEach(function (root) {
      if (root.dataset.mtInit) return;
      root.dataset.mtInit = '1';

      // Galería
      var principal = root.querySelector('[data-mt-principal]');
      root.querySelectorAll('[data-mt-mini]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          root.querySelectorAll('[data-mt-mini]').forEach(function (b) { b.classList.remove('is-activa'); });
          btn.classList.add('is-activa');
          principal.style.opacity = 0;
          setTimeout(function () {
            principal.src = btn.getAttribute('data-src');
            principal.removeAttribute('srcset');
            principal.style.opacity = 1;
          }, 180);
        });
      });

      // Cantidad
      var qty = root.querySelector('[data-mt-qty]');
      root.querySelectorAll('[data-mt-qty-btn]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-mt-qty-btn'), 10);
          qty.value = Math.max(1, v);
        });
      });

      // Variantes
      var dataEl = root.querySelector('[data-mt-variantes]');
      if (!dataEl) return;
      var variantes = JSON.parse(dataEl.textContent);
      var idInput = root.querySelector('input[name="id"]');
      var boton = root.querySelector('[data-mt-add]');
      var precio = root.querySelector('[data-mt-precio]');
      var formato = root.getAttribute('data-mt-moneda') || '{{amount_with_comma_separator}} €';
      function money(c) {
        var n = (c / 100).toFixed(2).replace('.', ',');
        return formato.replace(/\{\{\s*\w+\s*\}\}/, n);
      }
      root.querySelectorAll('[data-mt-opcion]').forEach(function (inp) {
        inp.addEventListener('change', function () {
          var sel = [];
          root.querySelectorAll('[data-mt-opcion]:checked').forEach(function (i) { sel.push(i.value); });
          var v = variantes.find(function (x) {
            return x.options.every(function (o, i) { return o === sel[i]; });
          });
          if (!v) { boton.disabled = true; boton.querySelector('span').textContent = boton.getAttribute('data-txt-nodisp'); return; }
          idInput.value = v.id;
          boton.disabled = !v.available;
          boton.querySelector('span').textContent = v.available ? boton.getAttribute('data-txt-add') : boton.getAttribute('data-txt-agotado');
          if (precio) {
            precio.innerHTML = money(v.price) + (v.compare_at_price > v.price ? ' <s>' + money(v.compare_at_price) + '</s>' : '');
          }
        });
      });
    });
  }

  function initResenas() {
    document.querySelectorAll('[data-mt-clamp]').forEach(function (txt) {
      var card = txt.closest('.mt-resena');
      var btn = card && card.querySelector('[data-mt-mas]');
      if (!btn || btn.dataset.mtInit) return;
      btn.dataset.mtInit = '1';
      if (txt.scrollHeight > txt.clientHeight + 2) btn.hidden = false;
      btn.addEventListener('click', function () {
        var abierta = card.classList.toggle('is-abierta');
        btn.textContent = abierta ? 'Leer menos' : 'Leer más';
      });
    });
    // Flechas del carrusel de opiniones (en ordenador no se puede deslizar con el ratón)
    document.querySelectorAll('[data-mt-resenas]').forEach(function (lista) {
      var marco = lista.closest('.mt-resenas__marco');
      var prev = marco && marco.querySelector('[data-mt-resenas-prev]'), next = marco && marco.querySelector('[data-mt-resenas-next]');
      if (!prev || !next || lista.dataset.mtFlechas) return;
      lista.dataset.mtFlechas = '1';
      var paso = function () { var c = lista.querySelector('.mt-resena'); return c ? c.getBoundingClientRect().width + 18 : lista.clientWidth * 0.8; };
      var estado = function () {
        prev.disabled = lista.scrollLeft <= 2;
        next.disabled = lista.scrollLeft + lista.clientWidth >= lista.scrollWidth - 2;
      };
      prev.addEventListener('click', function () { lista.scrollBy({ left: -paso(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { lista.scrollBy({ left: paso(), behavior: 'smooth' }); });
      lista.addEventListener('scroll', estado, { passive: true });
      window.addEventListener('resize', estado);
      estado();
    });
  }

  function initBarraCompra() {
    var barra = document.querySelector('[data-mt-barra]');
    if (!barra || barra.dataset.mtInit) return;
    barra.dataset.mtInit = '1';
    var datosEl = barra.querySelector('[data-mt-barra-variantes]');
    var variantes = datosEl ? JSON.parse(datosEl.textContent) : [];
    var nombre = barra.querySelector('[data-mt-barra-nombre]');
    var precio = barra.querySelector('[data-mt-barra-precio]');
    var boton = barra.querySelector('[data-mt-barra-btn]');
    var visible = null;

    function formulario() { return document.querySelector('product-info product-form') || document.querySelector('product-form'); }
    function botonPrincipal() { var f = formulario(); return f && f.querySelector('button[name="add"]'); }

    function mostrar(si) {
      if (si === visible) return;
      visible = si;
      barra.classList.toggle('is-visible', si);
      barra.setAttribute('aria-hidden', si ? 'false' : 'true');
      boton.tabIndex = si ? 0 : -1;
      document.body.classList.toggle('mt-barra-activa', si && getComputedStyle(barra).display !== 'none');
    }

    // Se muestra cuando el botón principal no está en pantalla (se busca cada vez: Dawn lo repinta al cambiar de variante)
    function comprobar() {
      var f = formulario();
      if (!f) { mostrar(false); return; }
      var r = f.getBoundingClientRect();
      mostrar(!(r.bottom > 0 && r.top < window.innerHeight));
    }

    function sincronizar() {
      var f = formulario();
      var idInput = f && f.querySelector('input[name="id"]');
      var v = idInput && variantes.find(function (x) { return String(x.id) === idInput.value; });
      if (v) { nombre.textContent = v.titulo; precio.textContent = v.precio; }
      var principal = botonPrincipal();
      if (principal) {
        boton.disabled = principal.disabled;
        boton.textContent = principal.disabled ? principal.textContent.trim() : boton.getAttribute('data-txt');
      }
      comprobar();
    }

    boton.addEventListener('click', function () {
      var principal = botonPrincipal();
      if (principal && !principal.disabled) principal.click();
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(sincronizar, 50); });
    }
    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('variant-selects')) setTimeout(sincronizar, 400);
    });
    window.addEventListener('scroll', comprobar, { passive: true });
    window.addEventListener('resize', comprobar);
    sincronizar();
  }

  // Tarjetas de packs: pulsan el botón de variante de Dawn (oculto) y se marcan según la variante elegida
  function initPacks() {
    var caja = document.querySelector('[data-mt-packs]');
    if (!caja || caja.dataset.mtInit) return;
    caja.dataset.mtInit = '1';
    var tarjetas = [].slice.call(caja.querySelectorAll('.mt-pack'));

    function selector() { return (caja.closest('product-info') || document).querySelector('variant-selects'); }
    function marcar(valor) {
      tarjetas.forEach(function (t) {
        var si = t.getAttribute('data-valor') === valor;
        t.classList.toggle('is-activo', si);
        t.setAttribute('aria-pressed', si ? 'true' : 'false');
      });
    }
    function leer() {
      var s = selector();
      var r = s && s.querySelector('input[type="radio"]:checked');
      if (r) marcar(r.value);
    }

    tarjetas.forEach(function (t) {
      t.addEventListener('click', function () {
        var valor = t.getAttribute('data-valor');
        var s = selector();
        var radio = s && [].slice.call(s.querySelectorAll('input[type="radio"]')).find(function (r) { return r.value === valor; });
        if (!radio) return;
        marcar(valor);
        if (!radio.checked) radio.click();
      });
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(leer, 30); });
    }
    caja.classList.add('is-listo');
    // Dawn cambia la dirección a ?variant=… y borra lo demás (fbclid, utm_…): se conservan para Meta y Shopify
    var extra = new URLSearchParams(location.search);
    extra.delete('variant');
    if (extra.toString() && !history.mtConserva) {
      history.mtConserva = true;
      var reemplazar = history.replaceState;
      history.replaceState = function (estado, titulo, url) {
        if (typeof url === 'string' && /[?&]variant=/.test(url)) {
          var u = new URL(url, location.href);
          extra.forEach(function (v, k) { if (!u.searchParams.has(k)) u.searchParams.set(k, v); });
          url = u.pathname + u.search + u.hash;
        }
        return reemplazar.call(history, estado, titulo, url);
      };
    }
    // Pack elegido al entrar (ajuste "preseleccion" del bloque; el HTML ya lo marca y solo viene si el enlace no trae ?variant=):
    // se pulsa su tarjeta para que Dawn cambie de variante (precio, carrito, "Comprar ahora" y barra fija)
    var presel = parseInt(caja.dataset.mtPreseleccion, 10);
    if (presel > 1 && tarjetas[presel - 1] && !/[?&]variant=/.test(location.search)) { tarjetas[presel - 1].click(); return; }
    leer();
  }

  // Carrusel de vídeos: cargan y se reproducen solo cuando se ven (como GIF), se paran al salir; toque = sonido
  function initVideos() {
    document.querySelectorAll('[data-mt-videos]').forEach(function (sec) {
      if (sec.dataset.mtInit) return;
      sec.dataset.mtInit = '1';
      var lista = sec.querySelector('[data-mt-videos-lista]');
      var videos = [].slice.call(sec.querySelectorAll('video[data-src]'));
      var mover = function (dir) { lista.scrollBy({ left: dir * (lista.clientWidth * 0.8), behavior: 'smooth' }); };
      var prev = sec.querySelector('[data-mt-videos-prev]'), next = sec.querySelector('[data-mt-videos-next]');
      if (prev) prev.addEventListener('click', function () { mover(-1); });
      if (next) next.addEventListener('click', function () { mover(1); });
      // Si el navegador no deja reproducir solo (iPhone con ahorro de batería o de datos, navegador de Instagram...),
      // se queda la portada con un botón de play: un toque y arranca
      var item = function (v) { return v.closest('.mt-videos__item'); };
      var arrancar = function (v) {
        if (!v.src) v.src = v.dataset.src;
        if (!v.poster && v.dataset.poster) v.poster = v.dataset.poster;
        var p = v.play();
        // NotAllowedError = el navegador no deja reproducir solo; AbortError (se pausó al salir de pantalla) no cuenta
        if (p && p.then) p.then(function () { item(v).classList.remove('pide-toque'); }, function (e) { if (!e || e.name === 'NotAllowedError') item(v).classList.add('pide-toque'); });
      };
      var ver = function (v, si) {
        if (si) arrancar(v);
        else if (!v.paused) v.pause();
      };
      sec.querySelectorAll('[data-mt-videos-play]').forEach(function (b) {
        b.addEventListener('click', function () { var v = item(b).querySelector('video'); v.muted = true; arrancar(v); });
      });
      // Las portadas (poster) se ponen al acercarse a la sección, para no competir con la foto principal al abrir la página
      var portadas = function () { videos.forEach(function (v) { if (!v.poster && v.dataset.poster) v.poster = v.dataset.poster; }); };
      if ('IntersectionObserver' in window) {
        var cerca = new IntersectionObserver(function (entradas) {
          if (entradas.some(function (e) { return e.isIntersecting; })) { portadas(); cerca.disconnect(); }
        }, { rootMargin: '900px 0px' });
        cerca.observe(sec);
        var io = new IntersectionObserver(function (entradas) {
          entradas.forEach(function (e) { ver(e.target, e.isIntersecting && e.intersectionRatio > 0.3); });
        }, { threshold: [0, 0.3, 0.6] });
        videos.forEach(function (v) { io.observe(v); });
      } else { portadas(); videos.forEach(function (v) { ver(v, true); }); }
      sec.querySelectorAll('[data-mt-videos-sonido]').forEach(function (b) {
        b.addEventListener('click', function () {
          var item = b.closest('.mt-videos__item'), v = item.querySelector('video');
          var activar = v.muted;
          videos.forEach(function (o) { o.muted = true; o.closest('.mt-videos__item').classList.remove('con-sonido'); });
          v.muted = !activar;
          item.classList.toggle('con-sonido', activar);
          b.setAttribute('aria-label', activar ? 'Quitar sonido' : 'Activar sonido');
          if (activar) { if (!v.src) v.src = v.dataset.src; v.play(); }
        });
      });
    });
  }

  function initPopup() {
    var pop = document.querySelector('[data-mt-popup]');
    if (!pop || pop.dataset.mtInit) return;
    pop.dataset.mtInit = '1';
    var CLAVE = 'mt_popup';
    function leer() { try { return JSON.parse(localStorage.getItem(CLAVE) || '{}'); } catch (e) { return {}; } }
    function guardar(o) { try { localStorage.setItem(CLAVE, JSON.stringify(o)); } catch (e) {} }
    var estado = leer();
    var enviado = pop.hasAttribute('data-enviado');
    var dias = parseInt(pop.dataset.dias, 10) || 30;
    var retraso = (parseInt(pop.dataset.retraso, 10) || 8) * 1000;
    var abierta = false;
    var tab = document.querySelector('[data-mt-popup-tab]');

    // Pestaña fija para recuperar el descuento: visible mientras la ventana está cerrada, salvo si ya se suscribió o la ocultó en esta visita
    function pestana(si) {
      if (!tab) return;
      var oculta = false;
      try { oculta = sessionStorage.getItem('mt_popup_tab') === 'no'; } catch (e) {}
      tab.hidden = !(si && !estado.suscrito && !oculta);
    }
    if (tab) {
      tab.querySelector('[data-mt-popup-tab-abrir]').addEventListener('click', function () { abrir(); });
      tab.querySelector('[data-mt-popup-tab-cerrar]').addEventListener('click', function () {
        try { sessionStorage.setItem('mt_popup_tab', 'no'); } catch (e) {}
        pestana(false);
      });
    }

    function abrir() {
      if (abierta) return;
      abierta = true;
      pestana(false);
      pop.hidden = false;
      document.body.classList.add('overflow-hidden');
      requestAnimationFrame(function () { requestAnimationFrame(function () { pop.classList.add('is-abierta'); }); });
      var email = pop.querySelector('input[type="email"]');
      if (email && !('ontouchstart' in window)) setTimeout(function () { email.focus(); }, 400);
    }
    function cerrar() {
      if (!abierta) return;
      abierta = false;
      pop.classList.remove('is-abierta');
      document.body.classList.remove('overflow-hidden');
      setTimeout(function () { pop.hidden = true; pestana(true); }, 400);
      if (!enviado) { estado.cerrado = Date.now(); guardar(estado); }
    }
    pop.querySelectorAll('[data-mt-popup-cerrar]').forEach(function (b) { b.addEventListener('click', cerrar); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') cerrar(); });

    // Tras enviar el formulario, Shopify recarga la página: se muestra el mensaje de éxito o el error
    if (enviado) { estado.suscrito = Date.now(); guardar(estado); abrir(); return; }
    if (pop.hasAttribute('data-error')) { abrir(); return; }
    if (estado.suscrito) return;
    pestana(true);
    if (estado.cerrado && Date.now() - estado.cerrado < dias * 864e5) return;
    if (/^\/(cart|checkouts?|account|challenge)/.test(location.pathname)) return;

    // Espera a que el cliente responda al banner de cookies y a que no haya otro panel abierto
    function ocupado() {
      var b = document.getElementById('shopify-pc__banner');
      var banner = b && getComputedStyle(b).display !== 'none' && getComputedStyle(b).visibility !== 'hidden';
      return banner || document.body.classList.contains('overflow-hidden');
    }
    setTimeout(function intentar() {
      if (ocupado()) { setTimeout(intentar, 1500); return; }
      abrir();
    }, retraso);
  }

  // "Comprar ahora": el botón de la ficha (y el de la barra fija, que lo pulsa) vacía el carrito, añade el pack elegido
  // y va directo a la pantalla de pago, sin pasar por el carrito (un paso menos). Si algo falla, envío normal del formulario.
  function initComprarAhora() {
    if (window.mtComprarAhora) return;
    window.mtComprarAhora = true;
    var json = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.closest || !form.closest('product-info') || !form.querySelector('input[name="id"]')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var btn = form.querySelector('button[name="add"]');
      if (btn) {
        if (btn.getAttribute('aria-disabled') === 'true') return;
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('loading');
        var giro = btn.querySelector('.loading__spinner');
        if (giro) giro.classList.remove('hidden');
      }
      var datos = new FormData(form);
      fetch('/cart/clear.js', { method: 'POST', headers: json })
        .then(function () { return fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: datos }); })
        .then(function (r) { if (!r.ok) throw new Error('add'); window.location.href = '/checkout'; })
        .catch(function () { HTMLFormElement.prototype.submit.call(form); });
    }, true);
  }

  // Carrito lateral: "Añade el 2.º por solo 5 €" cambia la línea al pack siguiente (snippets/cart-drawer.liquid)
  function initSubirPack() {
    if (window.mtSubirPack) return;
    window.mtSubirPack = true;
    var json = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-mt-subir-pack]');
      if (!b || b.disabled) return;
      e.preventDefault();
      b.disabled = true;
      b.classList.add('is-cargando');
      var cajon = document.querySelector('cart-drawer');
      var secciones = cajon && cajon.getSectionsToRender ? cajon.getSectionsToRender().map(function (s) { return s.id; }) : [];
      fetch('/cart/change.js', { method: 'POST', headers: json, body: JSON.stringify({ id: b.dataset.linea, quantity: 0 }) })
        .then(function () {
          return fetch('/cart/add.js', { method: 'POST', headers: json, body: JSON.stringify({ items: [{ id: Number(b.dataset.variante), quantity: 1 }], sections: secciones, sections_url: window.location.pathname }) });
        })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function (estado) { if (cajon && estado.sections) cajon.renderContents(estado); else window.location.reload(); })
        .catch(function () { window.location.reload(); });
    });
  }

  // Aviso solo para quien entra desde el navegador de Instagram/Facebook (el 87 % de las visitas): ahí no hay tarjetas guardadas,
  // Apple/Google Pay a menudo no salen y la verificación del banco (3D Secure) se pierde al volver de la app del banco.
  // Se le propone abrir la ficha en su navegador (Safari/Chrome). Android: intent:// abre Chrome; iOS 17+: x-safari-https://.
  function initNavegadorApp() {
    var ua = navigator.userAgent || '';
    if (!/FBAN|FBAV|FB_IAB|FBIOS|Instagram|Messenger/i.test(ua)) return;
    var botones = document.querySelector('product-info .product-form__buttons');
    if (!botones || document.querySelector('.mt-abrir-nav')) return;
    var ios = /iPhone|iPad|iPod/i.test(ua), android = /Android/i.test(ua);
    var sinEsquema = window.location.href.replace(/^https?:\/\//, '');
    var enlace = android ? 'intent://' + sinEsquema + '#Intent;scheme=https;package=com.android.chrome;end'
      : ios ? 'x-safari-https://' + sinEsquema : '';
    var cartera = ios ? 'Apple Pay' : 'Google Pay';
    var caja = document.createElement('div');
    caja.className = 'mt-abrir-nav';
    caja.innerHTML = '<p><strong>¿Prefieres pagar con ' + cartera + ' o con tus tarjetas guardadas?</strong> ' +
      'Ábrelo en tu navegador: toca los 3 puntos <b>⋯</b> de arriba y elige «Abrir en el navegador».</p>' +
      (enlace ? '<a href="' + enlace + '">Abrir en ' + (ios ? 'Safari' : 'Chrome') + ' →</a>' : '');
    botones.insertAdjacentElement('afterend', caja);
  }

  function init() { initReveal(); initParallax(); initProducto(); initResenas(); initBarraCompra(); initPacks(); initVideos(); initPopup(); initComprarAhora(); initSubirPack(); initNavegadorApp(); }
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
